module.exports = __webpack_public_path__ + "img/ci-wavve-112-x-24.f239a950.svg";